//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/messaging.proto (package dxos.mesh.messaging, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/messaging.proto.
 */
export const file_dxos_mesh_messaging: GenFile = /*@__PURE__*/
  fileDesc("ChlkeG9zL21lc2gvbWVzc2FnaW5nLnByb3RvEhNkeG9zLm1lc2gubWVzc2FnaW5nImIKD1JlbGlhYmxlUGF5bG9hZBIoCgptZXNzYWdlX2lkGAEgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRIlCgdwYXlsb2FkGAIgASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueSI7Cg9BY2tub3dsZWRnZW1lbnQSKAoKbWVzc2FnZV9pZBgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXliBnByb3RvMw", [file_google_protobuf_any, file_dxos_keys]);

/**
 * @generated from message dxos.mesh.messaging.ReliablePayload
 */
export type ReliablePayload = Message<"dxos.mesh.messaging.ReliablePayload"> & {
  /**
   * / Unique message identifier. Used for Acknolegment.
   *
   * @generated from field: dxos.keys.PublicKey message_id = 1;
   */
  messageId?: PublicKey;

  /**
   * / Payload for signal server netwrok.
   *
   * @generated from field: google.protobuf.Any payload = 2;
   */
  payload?: Any;
};

/**
 * Describes the message dxos.mesh.messaging.ReliablePayload.
 * Use `create(ReliablePayloadSchema)` to create a new message.
 */
export const ReliablePayloadSchema: GenMessage<ReliablePayload> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_messaging, 0);

/**
 * @generated from message dxos.mesh.messaging.Acknowledgement
 */
export type Acknowledgement = Message<"dxos.mesh.messaging.Acknowledgement"> & {
  /**
   * / MessageId of the Message that is being acknowledged.
   *
   * @generated from field: dxos.keys.PublicKey message_id = 1;
   */
  messageId?: PublicKey;
};

/**
 * Describes the message dxos.mesh.messaging.Acknowledgement.
 * Use `create(AcknowledgementSchema)` to create a new message.
 */
export const AcknowledgementSchema: GenMessage<Acknowledgement> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_messaging, 1);

